import {DefectButton} from "../types/product-card-defect.types";
import {resources} from "../../../../core/models/resource/resources";

export const productCardsDefectsResourceType = resources['product-cards-defects'];
export const productCardsDefectValuesResourceType = resources['product-cards-defect-values'];

export const defectButtons: Array<DefectButton> = [
  {
    label: 'Элемент товара',
    key: 'defect'
  },
  {
    label: 'Типичный дефект',
    key: 'defect-value'
  }
]
